import { cn, Input } from '@solinkcorp/solink-ui';

interface DayPartTimeInputProps {
  /** 24h format "HH:MM" */
  value: string;
  /** Receives 24h format "HH:MM" */
  onChange: (value: string) => void;
  disabled?: boolean;
  hasError?: boolean;
}

export const DayPartTimeInput = ({
  value,
  onChange,
  disabled,
  hasError,
}: DayPartTimeInputProps) => {
  return (
    <Input
      type="time"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={cn(
        'peer h-9 w-[120px] justify-center bg-background text-text-primary body-md-strong [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-datetime-edit-fields-wrapper]:mx-auto',
        hasError ? 'border-text-error' : '',
      )}
    />
  );
};
